import { render, staticRenderFns } from "./NeonMembershipTier.vue?vue&type=template&id=0bf6dae9&"
import script from "./NeonMembershipTier.vue?vue&type=script&lang=ts&"
export * from "./NeonMembershipTier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports